exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".categoryDetails{width:150px;text-align:right;border-right:1px solid #eee;padding-right:.75rem}.categoryDetails .action-icon{font-size:1.25rem;position:relative;top:.3rem}.categoryDetails a{color:#2c3e50;text-decoration:none;cursor:default}.categoryStats{font-size:.875rem;margin-right:.375rem}.editIcon.material-icons.action-icon{margin:0}@media (max-width:600px){.categoryDetails{text-align:left;width:auto;margin-left:.5rem;border-right:none;text-overflow:ellipsis;overflow:hidden}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-492bb009!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/CategoryDetailsBlock.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-492bb009!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/CategoryDetailsBlock.vue
// module chunks = 0